import * as types from './actionTypes';
import { getRequest, deleteRequest, postRequest, putRequest, patchRequest } from '../../lib/apiUtils';
import { TagNames, SettingNames } from '../../lib/constants';
import { getCampaigns } from './CampaignsActions';
import { getAllCampaignLists } from './CampaignListsActions';
import { getOrganizations } from './RecipientAccountsActions';
import { getApprovers } from './UsersActions';
import { getFunds } from './FundsActions';
import { getAllReferences } from './ReferencesActions';

export function getPrinters() {
    return async dispatch => {
        dispatch({ type: types.START_GET_PRINTERS });

        const response = await getRequest("/settings/printers", null, []);

        dispatch({ type: types.GET_PRINTERS, response });
        return response;
    };
}

export function getSystemSettings() {
    return async dispatch => {
        dispatch({ type: types.START_GET_SYSTEM_SETTINGS });

        const response = await fetchUtilsWithRetry("/settings", { AllSettings: true });

        dispatch({ type: types.GET_SYSTEM_SETTINGS, response });
    };
}

export function getPartialSystemSettings(setting) {
    return async dispatch => {

        dispatch({ type: types.START_GET_PARTIAL_SYSTEM_SETTINGS, setting })

        const response = await getRequest(`/settings?${setting}=true`);

        dispatch({ type: types.GET_PARTIAL_SYSTEM_SETTINGS, setting, response });
    }
}

export function getTags() {
    return async dispatch => {
        await Promise.all([
            dispatch(getCampaigns()),
            dispatch(getAllCampaignLists()),
            dispatch(getApprovers()),
            dispatch(getOrganizations()),
            dispatch(getFunds()),
            dispatch(getAllReferences())
        ]);
    };
}

async function fetchUtilsWithRetry(url, params, dataType) {
    try {
        let response = await getRequest(url, params, dataType);

        let i = 0;
        while (i < 4 && !response.success) {
            response = await getRequest(url, params, dataType);
            i++;
        }

        return {
            loading: false,
            success: response.success,
            data: response.data
        };
    }
    catch (error) {
        return {
            loading: false,
            success: false,
            data: dataType
        };
    }
}

export function deleteTag(tagName, tagId) {
    return async dispatch => {
        dispatch({ type: types.START_DELETE_TAG, tagName, tagId });

        const response = await deleteRequest(`/settings/${tagName}/${tagId}`);

        dispatch({ type: types.DELETE_TAG, response, tagName, tagId })
    }
}

export function addTag(tagName, tagValue) {
    return async dispatch => {
        dispatch({ type: types.START_ADD_TAG, tagName });
        const value = typeof (tagValue) === "string" ? { tagValue } : tagValue;
        const response = await postRequest(`/settings/${tagName}`, value, null);

        if (response.success) {
            if (typeof (tagValue) === "string") {
                response.data = { key: response.data, value: tagValue }
            } else {
                if (tagName === TagNames.CampaignCategories) response.data = { ...tagValue, campaignCategoryId: response.data };
                if (tagName === TagNames.LocationGroups) response.data = { ...tagValue, groupId: response.data }
            }
        }
        dispatch({ type: types.ADD_TAG, tagName, response })

    };
}

export function updateTag(tagName, tag) {
    return async dispatch => {
        dispatch({ type: types.START_UPDATE_TAG, tagName });
        
        const response = await putRequest(`/settings/${tagName}/${tag.key}`, { tagValue: tag.value }, null);
        
        if(response.success) {
            response.data = tag;
        }

        dispatch({ type: types.UPDATE_TAG, tagName, response })
    };
}

export function updateSetting(settingName, settingId, newSettingValue) {
    return async dispatch => {
        dispatch({ type: types.START_UPDATE_SETTING, settingName });
        const response = await putRequest(`/settings/${settingId}`, { newSettingValue });
        dispatch({ type: types.UPDATE_SETTING, response, settingName, value: newSettingValue });
    }
}

export function updateReturnAddress(address) {
    return async dispatch => {
        dispatch({ type: types.START_UPDATE_SETTING, settingName: SettingNames.ReturnAddress });
        const response = await putRequest('/settings/returnaddress', address);
        dispatch({ type: types.UPDATE_SETTING, response, settingName: SettingNames.ReturnAddress, value: address });
    }
}

export function updateDefaultFund(settingName, fundId) {
    return async dispatch => {
        dispatch({ type: types.START_UPDATE_SETTING, settingName });
        const response = await patchRequest(`/funds/${fundId}`, { isDefault: true });
        dispatch({ type: types.UPDATE_SETTING, response, settingName, value: fundId });
    }
}

export function updateLocationGroup(groupId, group) {
    return async dispatch => {
        const settingName = TagNames.LocationGroups;
        dispatch({ type: types.START_UPDATE_SETTING, settingName });
        const response = await putRequest(`/settings/campaignLocationGroups/${groupId}`, group);
        dispatch({ type: types.UPDATE_SETTING, response, settingName, value: group });
    }
}

export function saveSignature(signature) {
    return async dispatch => {
        const settingName = SettingNames.Signatures;
        dispatch({ type: types.START_UPDATE_SETTING, settingName });

        const formData = new FormData();
        for (const prop in signature) formData.append(prop, signature[prop]);
        const response = await postRequest('/settings/signatures', formData, { 'Content-Type': 'multipart/form-data' }, {});
        if (response.success) signature.fileId = 1;
        dispatch({ type: types.UPDATE_SETTING, response, settingName, value: signature });
    }
}



// WEBPACK FOOTER //
// ./src/redux/actions/SettingsActions.js